import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import Invitation from './Invitation'
import Email_template from './Email_template'
import Invitation_logs from './Invitation_logs'
import Campaingns from './Campaingns'
import Reminder from './Reminder'
import $ from 'jquery'

export default function Communication() {
    const navigate = useNavigate();
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const idarray = ['invitations', 'templates', 'campaigns', 'greetings', 'reminders', 'logs', 'templateslist'];
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        let targettab = localStorage.getItem('communications');
        if (targettab == 'invitation') {
            openControlTabs('invitations')
        }
        if (targettab == 'template') {
            openControlTabs('templates')
        }
        if (targettab == 'campaign') {
            openControlTabs('campaigns')
        }
        if (targettab == 'log') {
            openControlTabs('logs')
        }
        localStorage.setItem('communications', '');
    })

    function openControlTabs(typetext) {
        console.log(typetext)
        idarray.forEach(idval => {
            if (typetext === idval) {
                console.log('MATCH')
                $('#' + typetext).css('display', 'block');
                $('.' + typetext).addClass('activetabs');
            } else {
                $('#' + idval).css('display', 'none');
                $('.' + idval).removeClass('activetabs');
            }
        });
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Communications</h2>
                </div>

                <div className='vl_alltab'>
                    <button className='tabs invitations activetabs' onClick={() => openControlTabs('invitations')}>Invitations</button>
                    <button className='tabs templates' onClick={() => openControlTabs('templates')}>Email Templates</button>

                    <button className='tabs campaigns' onClick={() => openControlTabs('campaigns')}>Campaigns</button>

                    <button className='tabs reminders' onClick={() => openControlTabs('reminders')}>Reminders</button>
                    <button className='tabs logs' onClick={() => openControlTabs('logs')}>Logs</button>
                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_tab_content'>
                        <div className='contentbase mem_list' id="invitations">
                            <Invitation />
                        </div>
                        <div className='contentbase mem_list nodisplay' id="templates">
                            <Email_template />
                        </div>

                        <div className='contentbase mem_list nodisplay' id="campaigns">
                            <Campaingns />
                        </div>
                        <div className='contentbase mem_list nodisplay' id="greetings">

                        </div>
                        <div className='contentbase mem_list nodisplay' id="reminders">
                            <Reminder />
                        </div>
                        <div className='contentbase mem_list nodisplay' id="logs">
                            <Invitation_logs />
                        </div>
                    </div>
                </section>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
